<script>
import ValidationResultImage from './ValidationResultImage.vue'
import ValidationResultDetailData from './ValidationResultDetailData.vue'
import ValidationResultStatus from './ValidationResultStatus.vue'
import ValidationResultActions from './ValidationResultActions.vue'
import ValidationResultLegend from './ValidationResultLegend.vue'
export default {
  components: {
    ValidationResultImage,
    ValidationResultDetailData,
    ValidationResultStatus,
    ValidationResultActions,
    ValidationResultLegend
  },
  props: {
    header: { type: String },
    isOpened: { type: Boolean },
    closeDialog: { type: Function },
    order: { type: Object }
  },
  data: () => ({
    document: {},
    imageMaxWidth: 598, // backend restricted
    imageMaxHeight: 845, // backend restricted
    isLoading: false,
    documentData: {}
  }),
  computed: {
    userActionRequired() {
      return (
        this.documentData.validationStatus ===
        this.$enums.validationStatus.userActionRequired
      )
    }
  },
  methods: {
    load(document) {
      this.isLoading = true
      this.document = document
      this.getDocument()
    },
    async getDocument() {
      await this.$uploadService
        .getDocument(this.document.documentId)
        .then(response => {
          this.documentData = response
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    update() {
      this.$refs.resultImage.loadNextImage(0, true)
      this.getDocument()
      //make parent update itself right away
      this.$emit('updated', {
        updated: true,
        document: this.document
      })
    }
  }
}
</script>
<template>
  <v-dialog
    :value="isOpened"
    fullscreen
    persistent
    transition="dialog-bottom-transition"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <DialogBaseColoredTitle>
        <span id='header' class="wordBreak">{{ header }}</span>
      </DialogBaseColoredTitle>
      <DialogBaseCloseIcon color="white" @click="closeDialog" />
      <v-divider></v-divider>
      <DialogBaseText v-if="isLoading" align="center">
        <v-row>
          <v-col>
            <v-progress-circular indeterminate color="primary">
            </v-progress-circular>
          </v-col>
        </v-row>
      </DialogBaseText>
      <DialogBaseText v-else>
        <v-container>
          <v-row class="justify-center">
            <v-col
              cols="12"
              lg="5"
              class="pa-0 mr-2 ml-2"
              :style="
                $vuetify.breakpoint.lgAndUp
                  ? 'max-width: ' +
                    (imageMaxWidth + 2) +
                    'px;min-width: ' +
                    (imageMaxWidth + 2) +
                    'px;'
                  : ''
              "
            >
              <ValidationResultImage
                ref="resultImage"
                :document-id="document.documentId"
                :page-count="document.pageCount"
                :max-height="imageMaxHeight"
              />
            </v-col>
            <v-divider
              v-if="$vuetify.breakpoint.lgAndUp"
              class="mx-4 d-inline"
              vertical
            ></v-divider>
            <v-col cols="12" lg="5" class="pl-0 pr-0">
              <ValidationResultDetailData :document-data="documentData" />
              <ValidationResultStatus :document-data="documentData" />
              <ValidationResultActions
                v-if="userActionRequired"
                :document-data="documentData"
                :document-id="document.documentId"
                :order="order"
                @confirmed="update"
              />
              <v-divider class="mt-1 pb-1"></v-divider>
              <ValidationResultLegend />
            </v-col>
          </v-row>
        </v-container>
      </DialogBaseText>
      <v-divider></v-divider>
      <DialogBaseActions>
        <v-btn :id="'close_button'" color="primary" @click="closeDialog">
          <span>{{ $t('button.close') }}</span></v-btn>
      </DialogBaseActions>
    </v-card>
  </v-dialog>
</template>
